import { render, staticRenderFns } from "./SalesDetailList.vue?vue&type=template&id=909026b0&scoped=true&"
import script from "./SalesDetailList.vue?vue&type=script&lang=ts&"
export * from "./SalesDetailList.vue?vue&type=script&lang=ts&"
import style0 from "./SalesDetailList.vue?vue&type=style&index=0&id=909026b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "909026b0",
  null
  
)

export default component.exports